import axios from 'axios';
import Api from '../library/Api.js';
import base from './ServicoBase.js';

export default {

        getModel() {


                var form = {
                        id: null,
                        data: null,
                        id_cliente: null,
                        id_estabelecimento: null,
                        id_resp_controllare: null,
                        id_resp_local: null,
                        responsavel_local: "",
                        id_modelo: null,
                        obs: "",
                        data_cadastro: null,
                        id_cadastrador: null,
                        nome_cadastrador: "",
                        nota_final: "",
                        parecer_final: "",
                        emails_lista: "",
                        audit: "",
                        referencia: "",
                        seq_ano_mes_cliente: null,
                        publicado: null,
                        hora: "",

                        categorias: []
                }

                return form;
        },

        getListStatus() {
                return [
                        { value: 0, label: "Não Publicado" },
                        { value: 1, label: "Publicado" },
                        { value: 2, label: "Em Análise" },
                        { value: 3, label: "Reprovado" },
                ];
        },
        getNomeStatus(id) {

                console.log("getNomeStatus", id);
                if (id == null) {
                        id = 0;
                }
                if (id == 0) {

                        return "Não Publicado";
                }


                if (id == 1) {

                        return "Publicado";
                }


                if (id == 2) { return "Em Análise"; }



                if (id == 3) {

                        return "Reprovado";
                }


                return "Não Publicado";

        },

        getModelVisualizar() {

                return {
                        id: null,
                        data: null,
                        responsavel_local: "",
                        data_cadastro: null,
                        referencia: null,
                        id_cliente: null,
                        nome_cliente: "",
                        nome_estabelecimento: "",
                        nome_responsavel: "",
                        cliente_oculto: 0,
                        nota_final: 0,
                        nome_checklist: ""
                }
        },

        getById(id) {

                return Api.Call("inspecao/" + id + "", "get", {});

        },

        getViewCompleta(id) {
                return Api.Call("inspecao_show/" + id + "", "get", {});
        },

        salvar(form, fn_progress) {


                if (form.id != null && form.id != "") {
                        // var data = base.removeColumns( form, "cadastrado_por,valido,verificado,eliminado");
                        return Api.Call("inspecao/" + form.id + "", "PUT", form, fn_progress);
                } else {


                        return Api.Call("inspecao", "POST", form, fn_progress);


                }

        },
        delete(id) {
                return Api.Call("inspecao/" + id + "", "DELETE", {});
        },
        filtrar(page, search) {

                var data = { filtro: search, page: page, pagesize: process.env.VUE_APP_PAGESIZE }

                return Api.Call("inspecao_grid", "get", data);


        },

        getListCliente(data, order, order_type) {

                data["order"] = order;
                data["order_type"] = order_type;
                data["ret"] = "cliente";

                return Api.Call("inspecao?" + base.serialize(data), "get", data);


        },

        getList(data, order, order_type) {


                data["order"] = order;
                data["order_type"] = order_type;
                data["ret"] = "cliente";

                // var data = {filtro: filtro,  order: order, order_type: order_type}

                return Api.Call("inspecao?" + base.serialize(data), "get", data);


        },

        getListByParent(tabela, id_pai) {


                var data = { tabela: tabela, id_pai: id_pai }

                return Api.Call("inspecao_gridcad?" + base.serialize(data), "get", data);


        },

        salvarGrid(hd_json, ids_delete_json, tabela, id_pai) {

                var data = {
                        hd_json: hd_json,
                        ids_delete_json: ids_delete_json,
                        tabela: tabela,
                        id_pai: id_pai
                };

                return Api.CallFormData("inspecao_salvargrid", "POST", data);

        }


}
